var global_search_query = "";
var usfBlankImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
var usfProductImageWidths = [320, 480, 640, 800, 960, 1200];
var usfCollectionImageWarmupId = 0;

function usfGetSizedImageUrl(src, width) {
  if (!src) {
    return "";
  }

  var url = String(src);

  if (url.indexOf("cdn.shopify.com") === -1 || /\.(svg|gif)(\?|#|$)/i.test(url)) {
    return url;
  }

  var hash = "";
  var hashIndex = url.indexOf("#");

  if (hashIndex > -1) {
    hash = url.slice(hashIndex);
    url = url.slice(0, hashIndex);
  }

  url = url.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|\d+x|x\d+)(@2x)?(?=\.)/i, "");

  var query = "";
  var queryIndex = url.indexOf("?");

  if (queryIndex > -1) {
    query = url.slice(queryIndex + 1);
    url = url.slice(0, queryIndex);
  }

  query = query
    .split("&")
    .filter(function (param) {
      return param && param.split("=")[0] !== "width";
    })
    .join("&");

  width = parseInt(width, 10);

  if (!width) {
    return url + (query ? "?" + query : "") + hash;
  }

  return url + "?" + (query ? query + "&" : "") + "width=" + width + hash;
}

function usfGetImageSrcset(src, widths) {
  if (!src) {
    return "";
  }

  widths = widths && widths.length ? widths : usfProductImageWidths;

  return widths.map(function (width) {
    return usfGetSizedImageUrl(src, width) + " " + width + "w";
  }).join(", ");
}

function usfHideCollectionSsrFirstRow() {
  var ssrRow = document.getElementById("collection-ssr-first-row");

  if (ssrRow) {
    ssrRow.classList.add("is-hidden");
    ssrRow.setAttribute("hidden", "hidden");
    ssrRow.setAttribute("aria-hidden", "true");
  }
}

function usfShowCollectionSsrFirstRow() {
  var ssrRow = document.getElementById("collection-ssr-first-row");

  if (ssrRow) {
    ssrRow.classList.remove("is-hidden");
    ssrRow.removeAttribute("hidden");
    ssrRow.removeAttribute("aria-hidden");
  }
}

function usfGetCollectionSsrProductIds() {
  var ssrRow = document.getElementById("collection-ssr-first-row");

  if (!ssrRow) {
    return [];
  }

  return Array.prototype.map.call(
    ssrRow.querySelectorAll("[data-product-id]"),
    function (card) {
      return String(card.getAttribute("data-product-id") || "");
    }
  ).filter(Boolean);
}

function usfIsVisibleCollectionProduct(item) {
  if (!item) {
    return false;
  }

  if (item.title && String(item.title).toLowerCase().indexOf("duties") !== -1) {
    return false;
  }

  return item.totalInventory != 0;
}

function usfCanPreserveCollectionSsr(products) {
  var ssrProductIds = usfGetCollectionSsrProductIds();

  if (!ssrProductIds.length || !Array.isArray(products) || products.length < ssrProductIds.length) {
    return false;
  }

  return ssrProductIds.every(function (productId, index) {
    return String(products[index].product_id) === productId;
  });
}

function usfSyncCollectionSsrPrices(products, shopCurrency) {
  var ssrRow = document.getElementById("collection-ssr-first-row");

  if (!ssrRow || !Array.isArray(products)) {
    return;
  }

  var showCompareAtPrice = ssrRow.getAttribute("data-show-compare-at-price") === "true";
  var productsById = {};

  products.forEach(function (product) {
    productsById[String(product.product_id)] = product;
  });

  Array.prototype.forEach.call(ssrRow.querySelectorAll("[data-product-id]"), function (card) {
    var product = productsById[String(card.getAttribute("data-product-id") || "")];
    var priceContainer = card.querySelector(".product-block__price");

    if (!product || !priceContainer) {
      return;
    }

    while (priceContainer.firstChild) {
      priceContainer.removeChild(priceContainer.firstChild);
    }

    if (showCompareAtPrice && parseFloat(product.compareAtPrice) > 0) {
      var compareAtPrice = document.createElement("span");
      var priceFrom = document.createElement("span");

      compareAtPrice.className = "money";
      compareAtPrice.style.textDecoration = "line-through";
      compareAtPrice.style.color = "#999999";
      compareAtPrice.textContent = shopCurrency + " " + product.compareAtPrice;

      priceFrom.className = "price-from";
      priceFrom.textContent = "From";

      priceContainer.appendChild(compareAtPrice);
      priceContainer.appendChild(priceFrom);
    }

    var currentPrice = document.createElement("span");
    currentPrice.className = "money";
    currentPrice.textContent = shopCurrency + " " + product.maxprice;
    priceContainer.appendChild(currentPrice);
  });
}

function usfShowCollectionApiResults() {
  var results = document.getElementById("divresults");
  var searchContainer = results ? results.closest(".main_search_container") : null;

  if (searchContainer) {
    searchContainer.classList.add("collection-api-grid-ready");
  }
}

function usfSwapCollectionSsrToApiResults() {
  usfHideCollectionSsrFirstRow();
  usfShowCollectionApiResults();
}

function usfWaitForCollectionApiImages(limit, timeout) {
  var images = Array.prototype.slice.call(
    document.querySelectorAll("#divresults .product-block__img--primary"),
    0,
    limit || 4
  );

  if (!images.length) {
    return Promise.resolve();
  }

  var imagePromises = images.map(function (image) {
    if (image.complete) {
      return Promise.resolve();
    }

    if (typeof image.decode === "function") {
      return image.decode().catch(function () {});
    }

    return new Promise(function (resolve) {
      image.addEventListener("load", resolve, { once: true });
      image.addEventListener("error", resolve, { once: true });
    });
  });

  return Promise.race([
    Promise.all(imagePromises),
    new Promise(function (resolve) {
      setTimeout(resolve, timeout || 1200);
    })
  ]);
}

function usfCancelCollectionImageWarmup() {
  usfCollectionImageWarmupId += 1;
}

function usfWarmCollectionNextProductImages(limit) {
  var warmupId = ++usfCollectionImageWarmupId;
  var maxImages = typeof limit === "number" ? Math.max(0, limit) : Infinity;
  var libraryAttempts = 0;

  function schedule(callback) {
    setTimeout(callback, 100);
  }

  function unveilNext() {
    if (warmupId !== usfCollectionImageWarmupId) {
      return;
    }

    var image = document.querySelector(
      "#divresults .product-block__img--primary.lazyload:not([data-usf-warmed])"
    );

    if (!image || maxImages <= 0) {
      return;
    }

    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === "function") {
      image.setAttribute("data-usf-warmed", "true");
      image.setAttribute("loading", "eager");
      window.lazySizes.loader.unveil(image);
      maxImages -= 1;
      schedule(unveilNext);
    } else if (libraryAttempts < 40) {
      libraryAttempts += 1;
      schedule(unveilNext);
    }
  }

  unveilNext();
}

function usfShouldKeepCollectionSsr(searchFilter) {
  if (!searchFilter || !searchFilter.length) {
    return false;
  }

  for (var i = 0; i < searchFilter.length; i++) {
    var type = searchFilter[i].type;

    if (type === "query") {
      return false;
    }

    if (type !== "collection") {
      return false;
    }
  }

  return true;
}

/**
 * Heritage PDP uses admin tags heritage_ksa / heritage_uae (product-template.liquid).
 * searchV2 returns tags as a JSON string e.g. ["heritage_ksa"].
 * When a text search is active, hide products whose tags reference heritage.
 */
function usfProductTagsIncludeHeritage(tags) {
  if (tags == null || tags === "") {
    return false;
  }
  return String(tags).toLowerCase().indexOf("heritage") !== -1;
}

function usfSearchFilterHasQuery(searchFilter) {
  if (!searchFilter || !searchFilter.length) {
    return false;
  }
  for (var i = 0; i < searchFilter.length; i++) {
    if (searchFilter[i].type === "query" && String(searchFilter[i].label || "").trim() !== "") {
      return true;
    }
  }
  return false;
}

function usfFilterOutHeritageWhenSearching(products, searchFilter) {
  if (!Array.isArray(products) || !products.length) {
    return products;
  }
  if (!usfSearchFilterHasQuery(searchFilter)) {
    return products;
  }
  return products.filter(function (p) {
    return !usfProductTagsIncludeHeritage(p.tags);
  });
}

function usfNormalizeColorName(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/\s*\/\s*/g, " / ")
    .replace(/\s+/g, " ")
    .trim();
}

function usfNormalizeHexValue(value) {
  if (value == null) {
    return "";
  }

  value = String(value).trim();

  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value)) {
    return value;
  }

  if (/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value)) {
    return "#" + value;
  }

  return "";
}

function usfLookupColorDescriptionHex(colorName) {
  const target = usfNormalizeColorName(colorName);

  if (!target) {
    return "";
  }

  const colorDescription = RenderColor.data().color_description || [];

  for (let i = 0; i < colorDescription.length; i++) {
    const [name, hex] = colorDescription[i];

    if (usfNormalizeColorName(name) === target) {
      return hex;
    }
  }

  return "";
}

function usfParseColorDescriptionHex(hex) {
  const colors = String(hex || "")
    .split(",")
    .map(usfNormalizeHexValue)
    .filter(Boolean);

  return {
    hex: colors[0] || "",
    hex2: colors[1] || null,
  };
}

function usfNormalizeApiColorSwatches(colors) {
  if (!Array.isArray(colors)) {
    return [];
  }

  return colors.map(function (item) {
    const normalized = Object.assign({}, item);
    const fallback = usfParseColorDescriptionHex(
      usfLookupColorDescriptionHex(normalized.color)
    );
    const hex = usfNormalizeHexValue(normalized.hex) || fallback.hex;
    const hex2 = usfNormalizeHexValue(normalized.hex2) || fallback.hex2;

    normalized.hex = hex || "#ddd";
    normalized.hex2 = hex2 || null;
    normalized.isTwoTone = Boolean(normalized.hex2 || normalized.isTwoTone);

    return normalized;
  });
}

/**COMPNENT FOR SIZE START**/
const RenderSize = {
  props: {
    variants: String,
    mainproductid: String
  },
  data: function () {
    return {
      template: '' 
    }
  },
  mounted() {
    this.uf_render();
  },
  methods: {
    uf_render: function(index){
      let variants =  JSON.parse(this.variants);
      let phtml = '';
      let id = '';
      let title = '';
      let availableForSale = '';
      let price = '';

      
      /* for (var i = 0; i < variants.length; i++) {
        id = variants[i]['node']['id'];
        title = variants[i]['node']['title'];
        availableForSale = variants[i]['node']['availableForSale'];
        price = variants[i]['node']['price'];

        let arr_title = title.split('/');
        let size_text = arr_title[0].trim();
        let arr_size = size_text.split('-');
        if (arr_size[0].length <= 6) {
          if (availableForSale){
      phtml = phtml+`<span class="in_stock" title="In Stock" onclick="uf_addCart(`+id+`)">`+arr_size[0].trim()+`</span>`;
          }else{
      phtml = phtml+`<span class="out_of_stock" title="Out Of Stock">`+arr_size[0].trim()+`</span>`;
          }
        }
      } */

      this.template = phtml;              
    }
  },        
  template: `<div class="size_container" v-html="this.template"></div>`
}
/**COMPNENT FOR SIZE END**/

/**COMPNENT FOR COLOR START**/
const RenderColor = {
  props: {
    metafields: String,
    mainproductid: String,
    availcolors: String,
    product: Object
  },
  data: function () {
    return {
      template: '',
      color_description: [
        ["Cashmere Rose", "#ce879f"],
        ["Deep Blue", "#3e4071"],
        ["Jester Red", "#751921"],
        ["Dark Earth", "#4d2e19"],
        ["Turkish Coffee", "#706f48"],
        ["Rio Red", "#751922"],
        ["Peppercorn", "#bfbdbb"],
        ["Jet Black", "#383e4e"],
        ["Stone Grey", "#939597"],
        ["White Cloud", "#edede6"],
        ["Leafy Khaki", "#706f48"],
        ["Sea Sage Green", "#96a480"],
        ["Natural Taupe", "#af9483"],
        ["Sunset Red", "#d1332c"],
        ["Cherry Red", "#d1332c"],
        ["Violet Blue", "#464f75"],
        ["Ocean Pale Blue", "#9cc3dc"],
        ["Pastel Lavendar", "#b9b3d1"],
        ["Pastel Pink", "#f7c8c2"],
        ["Steel Blue", "#999fbf"],
        ["Wheat", "#cdbfba"],
        ["Slate Green", "#81988e"],
        ["Pink", "#fbd8db"],
        ["Lavender", "#b7a0bb"],
        ["White", "#ffffff"],
        ["Navy", "#293a65"],
        ["Powder Blue", "#d8eff5"],
        ["Muted Blue", "#e8edf0"],
        ["Warm Beige", "#ede3d4"],
        ["Nectar", "#ecdacc"],
        ["Brown", "#6a493c"],
        ["Stone", "#baafa4"],
        ["Offwhite", "#f2ede4"],
        ["Ivory", "#fff9e6"],
        ["Light Pink", "#f0d5d2"],
        ["Sky Blue", "#b9cfe3"],
        ["Olive", "#7e9055"],
        ["Green", "#777c63"],
        ["Mustard Yellow", "#dccc50"],
        ["Red", "#e00030"],
        ["Butter Yellow", "#fff3bc"],
        ["Blush Pink", "#f0d5d2"],
        ["Rust Brown", "#81553d"],
        ["Taupe", "#967e6c"],
        ["Charcoal Grey", "#636364"],
        ["Feminine Pink", "#C599C7"],
        ["Black", "#000000"],
        ["Pale Lavender", "#B9B3D1"],
        ["Grey", "#939597"],
        ["Beige", "#EDE3D4"],
        ["Pale Blue", "#9CC3DC"],
        ["Warm Taupe", "#BB9C8A"],
        ["Cafe", "#6A493C"],
        // Two-toned colors
        ["Sky Blue / Ivory", "#b9cfe3,#fff9e6"],
        ["White / Navy", "#ffffff,#293a65"],
        ["Brown / Offwhite", "#bd9f83,#f2ede4"],
        ["Ivory / Brown", "#fff9e6,#6a493c"],
        ["Light Pink / Ivory", "#f0d5d2,#fff9e6"],
        ["Brown / Stone", "#6a493c,#baafa4"],
        ["Ivory / Green", "#fff9e6,#777c63"],
        ["Olive / Mustard Yellow", "#7e9055,#dccc50"]
      ]
    }
  },
  mounted() {
    this.uf_render();
  },
  methods: {
    isTwoTone(hexColor) {
      return hexColor && hexColor.includes(',');
    },
    parseHexColors(hexColor) {
      if (this.isTwoTone(hexColor)) {
        const colors = hexColor.split(',').map(c => c.trim());
        return {
          isTwoTone: true,
          color1: colors[0],
          color2: colors[1]
        };
      }
      return {
        isTwoTone: false,
        color1: hexColor,
        color2: null
      };
    },
    sortByKey: function (array, key) {
      return array.sort((a, b) => {
        let x = a[key];
        let y = b[key];

        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    },   
    uf_render: function(index){
      let metafields =  JSON.parse(this.metafields);
      let phtml = ''
      let pcolor = '';
      let phandle = '';
      let pkey = '';
      let pvalue = '';
      let ptitle = '';
  
      const colorMap = {
        "#ce879f": "18",
        "#bfbdbb": "17",
        "#751922": "16",
        "#706f48": "15", // normalized to lowercase
        "#4d2e19": "14",
        "#751921": "13",
        "#3e4071": "12",
        "#383e4e": "11",
        "#939597": "10",
        "#edede6": "9",
        "#96a480": "8",
        "#96a480": "7",
        "#af9483": "6",
        "#d1332c": "5",
        "#464f75": "4",
        "#9cc3dc": "3",
        "#b9b3d1": "2",
        "#f7c8c2": "1",
      };

      for (let i = 0; i < metafields.length; i++) {
        let pvalue = metafields[i].node.value.toLowerCase();

        for (const color in colorMap) {
          if (pvalue.includes(color)) {
            metafields[i].node.sort_col = colorMap[color];
            break;
          }
        }
      }

        
      //   if (pvalue.indexOf("#383e4e")>-1){
      //     metafields[i]['node']['sort_col']  = '1';
      //   }else if(pvalue.indexOf("#939597")>-1){
      //     metafields[i]['node']['sort_col']  = '2';
      //   }else if(pvalue.indexOf("#edede6")>-1){
      //     metafields[i]['node']['sort_col']  = '3';
      //   }else if(pvalue.indexOf("#706f48")>-1){
      //     metafields[i]['node']['sort_col']  = '4';
      //   }else if(pvalue.indexOf("#96a480")>-1){
      //     metafields[i]['node']['sort_col']  = '5';
      //   }else if(pvalue.indexOf("#af9483")>-1){
      //     metafields[i]['node']['sort_col']  = '6';
      //   }else if(pvalue.indexOf("#d1332c")>-1){
      //     metafields[i]['node']['sort_col']  = '7';
      //   }else if(pvalue.indexOf("#464f75")>-1){
      //     metafields[i]['node']['sort_col']  = '8';
      //   }else if(pvalue.indexOf("#9cc3dc")>-1){
      //     metafields[i]['node']['sort_col']  = '9';
      //   }else if(pvalue.indexOf("#b9b3d1")>-1){
      //     metafields[i]['node']['sort_col']  = '10';
      //   }else if(pvalue.indexOf("#f7c8c2")>-1){
      //     metafields[i]['node']['sort_col']  = '11';
      //   }else if(pvalue.indexOf("#751921")>-1){
      //     metafields[i]['node']['sort_col']  = '12';
      //   }else if(pvalue.indexOf("#4d2e19")>-1){
      //     metafields[i]['node']['sort_col']  = '13';
      //   }else if(pvalue.indexOf("#706F48")>-1){
      //     metafields[i]['node']['sort_col']  = '14';
      //   }else if(pvalue.indexOf("#3e4071")>-1){
      //     metafields[i]['node']['sort_col']  = '15';
      //   }else if(pvalue.indexOf("#751922")>-1){
      //     metafields[i]['node']['sort_col']  = '16';
      //   } 
      // }
      metafields = metafields.filter((metafield) => metafield.node.key.includes('product_color'))
        .sort(function(a, b){
          return a.node.sort_col - b.node.sort_col;
        }).map((metafield) => {
          const value = metafield.node.value.split('|');
          const hexColor = value[0]; // Could be "#000000" or "#000000,#ffffff"
          const handle = value[1];
          
          // Parse the hex color(s)
          const colorData = this.parseHexColors(hexColor);
          
          // Find color name - check both single and two-tone
          const color = this.color_description.find((color) => {
            return color[1].toLowerCase().trim() === hexColor.toLowerCase().trim();
          });
          const colorName = color ? color[0] : '';

          metafield.node = {
            ...metafield.node,
            hexColor: colorData.color1,
            hexColor2: colorData.color2,
            isTwoTone: colorData.isTwoTone,
            colorName,
            handle
          };

          return metafield;
        });

        const current = JSON.parse(this.availcolors);
        const originalMetafields = metafields;
        let metafields_count = 0;
        let currentIndex = -1;
        const limit = 4;
  
        if (current) {
          const currentColor = current[0].Color;
          const currentHandle = current[0].Handle;
          currentIndex = metafields.findIndex((metafield) => metafield.node.colorName == currentColor);
          if (currentIndex === -1) {
            currentIndex = metafields.findIndex((metafield) => metafield.node.handle == currentHandle);
          }
        }
  
        if (currentIndex !== -1) {
          metafields = metafields.splice(currentIndex, limit);
          metafields_count = metafields.length;
          if (metafields_count < limit) {
            metafields = [
              ...metafields,
              ...originalMetafields.splice(0, limit - metafields_count),
            ];
          }
        }
  
        if (metafields.length > limit) {
          metafields = metafields.splice(0, 4);
        }
  
        // Build HTML with two-tone support
        metafields.forEach((metafield) => {
          const node = metafield.node;
          let swatchStyle = '';
          let swatchClass = 'swatch__color swatch__color--black';
          
          if (node.isTwoTone) {
            // Two-tone: diagonal gradient
            swatchStyle = `background: linear-gradient(90deg, ${node.hexColor} 50%, ${node.hexColor2} 50%);`;
            swatchClass += ' swatch__color--two-tone';
          } else {
            // Single color
            swatchStyle = `background-color: ${node.hexColor};`;
          }
  
          phtml += `
            <div class="swatch__element">
              <div class="swatch__label">
                <span class="${swatchClass}" style="${swatchStyle}"></span>
              </div>
              <a href="javascript: void(0)" onclick="uf_swatchColor(this)" data-url="${node.handle}" data-main-product-id="${this.mainproductid}" class="swatch__link swatch__image" title="${node.colorName}">${node.handle}</a>
            </div>
          `;
        });
  
        if (phtml != '') {
          phtml = `
            <div class="product-block__swatch swatch--circle" style="min-height: inherit;">
              <div class="custom_product_color" style="min-height: inherit;">
                ${phtml}
              </div>
            </div>
          `;
        }
        
        this.template = phtml;
    }
  },        
  template: `<div v-html="this.template"></div>`
}
/**COMPNENT FOR COLOR END**/
  
const SearchPageOptions = {
    name: 'Search Page',
    data(){
      return {
        appendToUrl: false,
        mediaQuery: null,
        screenSize: null,
        isMobile: null,
        productView: 'grid',
        searchTerm: 'Shoes',
        show_filters: true,
        show_filter_body: true,
        submit_filter: false,
        shop_currency: 'AED',
        currency: null,
        items: [],
        main_result: [],
        search_filter: [],
        sort_by: [],
        promotion_filter: [],
        color_filter: [],
        category_filter: [],
        size_filter: [],
        fit_filter: [],
        price_filter: [],
        selected_sort_by: 0,
        selected_promotion: [],
        selected_color: [],
        selected_category: [],
        selected_size: [],
        selected_fit: [],
        minPrice: 0,
        maxPrice: 0,
        minRangeValue: 0,
        maxRangeValue: 0,
        formattedMinRangeValue: null,
        formattedMaxRangeValue: null,
        minRangePosition: 0,
        maxRangePosition: 0,
        dragging: null,
        search_result_maxid: 0,
        search_result_maxlength: 0,
        groupings: [],
        showGroupings: true,
        showBundleBanner: false,
        showB1G1Banner: false,
        selected_group: 'group_all',
        loading: true,
        minAngle: 0,
        maxAngle: 1000,
        defaultMaxPrice: 1000,
        defaultMinPrice: 0,
        price_filter_id: '',
        total_records: 0,
        show_selected_filters: false,
        show_gender_filter: false,
        show_no_result: false,
        mobile_product_size: [],
        mobile_product_title: '',
        mobile_product_image: '',
        mobile_product_price: '',
        mobile_product_selected_variant: '',
        blankImage: window.theme && window.theme.icons && window.theme.icons.blank ? window.theme.icons.blank : usfBlankImage,
        loadMoreScrollHandler: null,
        loadMoreResizeHandler: null,
        searchRequestId: 0,
        earlySearchUsed: false,
        preserveSsrFirstRow: false,
        ssrProductCount: 0
        
      }
    },
    mounted() {
      this.mediaQuery = window.matchMedia("(max-width: 768px)")
      this.updateScreenSize(this.mediaQuery)
      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.updateScreenSize)
      } else if (this.mediaQuery.addListener) {
        this.mediaQuery.addListener(this.updateScreenSize)
      }
      this.setupLoadMoreFallback()
    },
    created() {
      collection = window._usf_collection_handle;
      search_query = window._usf_query;
      this.shop_currency = window.shop_currency

      /* if (collection.indexOf("kids")>-1){
        this.show_gender_filter = true;
      } */

      const url = new URL(location.href)
      const { searchParams } = url
      const filters = searchParams.get('filters')
      const decoded = JSON.parse(decodeURIComponent(filters))

      if (collection != 'all') {
        const hasCollectionFilter = decoded != null && decoded.some((filter) => filter.type == 'collection')

        if (!hasCollectionFilter) {
          this.search_filter.push({
            'type':'collection',
            'label': collection
          });
        }
      } else {
        if (search_query) {
          global_search_query = search_query;

          this.search_filter.push({
            type: 'query',
            label: search_query
          })
        } else {
          this.search()
        }
      }

      if (searchParams.has('filters')) {
        decoded.forEach((filter) => {
          const { type, label: value } = filter

          switch (type) {
            case 'sort_by':
              this.selected_sort_by = value
            break;
            case 'promotion':
              this.selected_promotion.push(value)
            break;
            case 'color':
              this.selected_color.push(value)
            break;
            case 'category':
              this.selected_category.push(value)
            break;
            case 'size':
              this.selected_size.push(value)
            break;
            case 'fit':
              this.selected_fit.push(value)
            break;
            case 'min_price':
              this.minRangeValue = value
            break;
            case 'max_price':
              this.maxRangeValue = value
            break;
          }

          this.search_filter.push(filter)
        })
      }

      this.submit_filter = true

      // this.showfilters();
      
    },
    beforeDestroy() {
      if (this.mediaQuery) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.updateScreenSize)
        } else if (this.mediaQuery.removeListener) {
          this.mediaQuery.removeListener(this.updateScreenSize)
        }
      }
      this.teardownLoadMoreFallback()
    },
    beforeUnmount() {
      if (this.mediaQuery) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.updateScreenSize)
        } else if (this.mediaQuery.removeListener) {
          this.mediaQuery.removeListener(this.updateScreenSize)
        }
      }
      this.teardownLoadMoreFallback()
    },
    watch: {
      search_filter: {
        handler(newValue) {
          if (!this.isMobile) {
            this.submit_filter = true
          }

          if (this.submit_filter) {
            if (this.appendToUrl) {
              newValue = newValue.filter(({ type }) => {
                const allowed = ['collection', 'query']

                return !allowed.includes(type)
              })

              const filters = JSON.stringify(newValue)
              const encoded = encodeURIComponent(filters)
              const url = new URL(location.href)
              const { searchParams } = url

              if (newValue.length > 0) {
                searchParams.set('filters', encoded)
              } else {
                searchParams.delete('filters')
              }

              window.history.pushState({}, '', url)
            }

            this.search()
          }

          this.submit_filter = false
        },
        deep: true
      }
    },
    computed: {
      visibleItems() {
        return this.items.filter(usfIsVisibleCollectionProduct)
      },
      renderedItems() {
        if (this.preserveSsrFirstRow && this.ssrProductCount > 0) {
          return this.visibleItems.slice(this.ssrProductCount)
        }

        return this.visibleItems
      },
      sliderMin: {
        get: function() {
          var val = parseInt(this.minAngle);
          return this.compute_currency(val);
        },
        set: function(val) {
          val = parseInt(val);
          if (val > this.maxAngle) {
            this.maxAngle = val;
          }
          this.minAngle = val;

          var currency = $("#currency_value").attr('doubly-currency');
          if (currency==''){
          currency = 'AED';
          }
          
          if (this.maxAngle == this.defaultMaxPrice && this.minAngle == this.defaultMinPrice){
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              this.search_filter.splice(index, 1);
            }             
          }else{
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter[index].label = label;
              this.search_filter[index].minprice = this.minAngle;
              this.search_filter[index].maxprice = this.maxAngle;
            }else{ 
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter.push({'id':this.price_filter_id,'type':'price','minprice':this.minAngle,'maxprice':this.maxAngle,'label':label});
            }
          }

          //Refresh Currency Display
          setTimeout(function() {
            $("[name=doubly-currencies]").trigger('change');   
          }, 1500)
          
        }
      },
      sliderMax: {
        get: function() {
          var val = parseInt(this.maxAngle);
          return this.compute_currency(val);
        },
        set: function(val) {
          val = parseInt(val);
          if (val < this.minAngle) {
            this.minAngle = val;
          }
          this.maxAngle = val;

          var currency = $("#currency_value").attr('doubly-currency');
          if (currency==''){
          currency = 'AED';
          }
          
          if (this.maxAngle == this.defaultMaxPrice && this.minAngle == this.defaultMinPrice){
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              this.search_filter.splice(index, 1);
            }             
          }else{
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter[index].label = label;
              this.search_filter[index].minprice = this.minAngle;
              this.search_filter[index].maxprice = this.maxAngle;
            }else{ 
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter.push({'id':this.price_filter_id,'type':'price','minprice':this.minAngle,'maxprice':this.maxAngle,'label':label});
            }
          }

          //Refresh Currency Display
          setTimeout(function() {
            $("[name=doubly-currencies]").trigger('change');   
          }, 1500)
        }
      }
    },
  methods: {
    isEagerProductImage(index) {
      return index < 4
    },
    getProductAbsoluteIndex(index) {
      return this.preserveSsrFirstRow ? index + this.ssrProductCount : index
    },
    productImageDefaultWidth() {
      if (this.productView === 'flex') {
        return 960
      }

      return this.isMobile ? 480 : 640
    },
    getProductImageUrl(src, width) {
      return usfGetSizedImageUrl(src, width || this.productImageDefaultWidth())
    },
    getProductImageSrcset(src) {
      return usfGetImageSrcset(src, usfProductImageWidths)
    },
    getProductImageSizes() {
      if (this.productView === 'flex') {
        return '100vw'
      }

      return '(max-width: 768px) 50vw, 25vw'
    },
    getProductImageSrc(src, index) {
      if (this.isEagerProductImage(index)) {
        return this.getProductImageUrl(src, this.productImageDefaultWidth())
      }

      return this.blankImage
    },
    setupLoadMoreFallback() {
      if ('IntersectionObserver' in window || this.loadMoreScrollHandler) {
        return
      }

      var vm = this
      var loaded = false
      var ticking = false

      function checkLoadMore() {
        ticking = false

        var loadMoreBtn = document.getElementById('loadMoreBtn')

        if (!loadMoreBtn || loadMoreBtn.offsetParent === null) {
          loaded = false
          return
        }

        var rect = loadMoreBtn.getBoundingClientRect()
        var isNearViewport = rect.top <= window.innerHeight + 200 && rect.bottom >= -200

        if (isNearViewport) {
          if (!loaded) {
            loaded = true
            vm.search_load_more()
          }
        } else {
          loaded = false
        }
      }

      function requestCheck() {
        if (ticking) {
          return
        }

        ticking = true

        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(checkLoadMore)
        } else {
          setTimeout(checkLoadMore, 16)
        }
      }

      this.loadMoreScrollHandler = requestCheck
      this.loadMoreResizeHandler = requestCheck
      window.addEventListener('scroll', requestCheck, { passive: true })
      window.addEventListener('resize', requestCheck)
      requestCheck()
    },
    teardownLoadMoreFallback() {
      if (this.loadMoreScrollHandler) {
        window.removeEventListener('scroll', this.loadMoreScrollHandler)
        this.loadMoreScrollHandler = null
      }

      if (this.loadMoreResizeHandler) {
        window.removeEventListener('resize', this.loadMoreResizeHandler)
        this.loadMoreResizeHandler = null
      }
    },
    showfilters(){
      let show_filter = false;
      for (var x = 0; x < this.search_filter.length; x++) {
        filter =  this.search_filter[x]['type'];
        if (filter=='price'||filter=='color'||filter=='size'||filter=='gender'||filter=='squery'){
          show_filter = true;
          break;
        } 
      }
      this.show_selected_filters = show_filter;
    },
    compute_currency(val){
      currency_value = $("#currency_value").html();
      var numb = currency_value.match(/\d/g);
      numb = numb.join("");          

      if (numb!=''){
        numb = numb/10;
      }else{
        numb = 1;
      }  

      return Math.round(val*numb);
    },
    search_group(group){
      usfSwapCollectionSsrToApiResults()

      let index = this.search_filter.map((el) => el.type).indexOf('group');
      if (index > -1) {
        this.search_filter.splice(index, 1);
      }             

      this.selected_group = '';
      if (group!='group_all' && group!=''){
        this.search_filter.push({'id':'111_group','type':'group','css_group':group});
      }
      this.selected_group = group;

      let queryString = JSON.stringify(this.search_filter)
      queryString = queryString.replace('&','xxx');

      let queryString_encoded = encodeURI(queryString);

      url_search = 'https://app.glossylounge.com/api/search/?query='+queryString_encoded;
      fetch(url_search)
      .then(response=>response.json())
      .then(suggestions=> {
        this.items=suggestions;
      })

    },
    async search() {
      const search_filters = this.search_filter
      const keepCollectionSsr = usfShouldKeepCollectionSsr(search_filters)

      usfCancelCollectionImageWarmup()

      if (!keepCollectionSsr) {
        this.preserveSsrFirstRow = false
        this.ssrProductCount = 0
        usfSwapCollectionSsrToApiResults()
      }

      const default_filters = search_filters.filter(({ type }) => {
        const allowed = ['collection', 'query']

        return allowed.includes(type)
      })

      const group_params = encodeURIComponent(JSON.stringify(default_filters))
      const search_params = encodeURIComponent(JSON.stringify(search_filters))
      let url_group = 'https://app.glossylounge.com/api/groupingV2/'
      let url_search = 'https://app.glossylounge.com/api/searchV2/'

      if (default_filters.length > 0) {
        url_group += `?query=${group_params}`
      }
      
      if (search_filters.length > 0) {
        url_search += `?query=${search_params}`
      }


      const requestId = this.searchRequestId = this.searchRequestId + 1

      // Reuse the product fetch kicked off early in the page <head> when it matches this exact
      // (default, unfiltered) query; otherwise fetch fresh. Falls back to a fresh request if the
      // early fetch failed for any reason.
      let searchFetch
      if (
        window.__usfEarlySearch &&
        window.__usfEarlySearch.url === url_search &&
        !this.earlySearchUsed
      ) {
        this.earlySearchUsed = true
        searchFetch = window.__usfEarlySearch.promise.catch(() =>
          fetch(url_search).then((response) => response.json())
        )
      } else {
        searchFetch = fetch(url_search).then((response) => response.json())
      }

      const groupFetch = fetch(url_group).then((response) => response.json())

      // Facets / filter panel. Independent of the product grid, so a failure here cannot block products.
      groupFetch
        .then((response) => {
          if (requestId !== this.searchRequestId) return

          const refs = this.$refs

          if (this.sort_by.length == 0) {
            this.sort_by = [
              'Relevance',
              'Newest',
              'Price: Low to High',
              'Price: High to Low',
            ]
          }

          if (this.promotion_filter.length == 0) {
            this.promotion_filter = [
              // '70% OFF',
              // 'BUY 2 GET 2 FREE',
            ]
          }

          if (this.color_filter.length == 0) {
            this.color_filter = usfNormalizeApiColorSwatches(response['colors'])
          }

          if (this.category_filter.length == 0) {
            this.category_filter = response['categories']
          }

          if (this.size_filter.length == 0) {
            this.size_filter = response['sizes']
          }

          if (this.fit_filter.length == 0) {
            if (window._usf_collection_handle != 'accessories' && window._usf_collection_handle != 'le-26') {
              this.fit_filter = [
                'Regular Fit',
                'Oversized',
              ]
            }
          }

          if (this.price_filter.length == 0) {
            const price_filter = this.price_filter = response['prices']

            this.minPrice = 0
            this.maxPrice = price_filter.max

            if (this.maxRangeValue === 0) {
              this.maxRangeValue = this.maxPrice
            }

            refs.minRangeValue.removeAttribute('doubly-currency')
            refs.maxRangeValue.removeAttribute('doubly-currency')
          }

          refs.sliderPrices.style.display = 'flex'
        })
        .catch(() => {})

      // Products drive LCP, so render them as soon as they arrive, independent of grouping.
      searchFetch
        .then((result) => {
          if (requestId !== this.searchRequestId) return
            this.main_result = usfFilterOutHeritageWhenSearching(result, this.search_filter)

            current_url = window.location.href

            const wishlist = this.get_wishlist()

            this.main_result = this.main_result.map((product) => {
                const variants = JSON.parse(product.variants)

                const compareAtPrice = variants
                    .filter((variant) => variant.node.compareAtPrice !== undefined)
                    .map((variant) => parseFloat(variant.node.compareAtPrice))

                if (compareAtPrice.length > 0) {
                    product.compareAtPrice = Math.max(...compareAtPrice)
                } else {
                    product.compareAtPrice = 0
                }

                product.in_wishlist = wishlist.includes(product.product_id)
                product.show_outlet = product.tags.includes('"outlet"')
                    ? 'yes'
                    : 'no'

                return product
            })

            let x = 1
            let final_result = []

            //pagination
            if (this.main_result.length >= 20) {
                this.search_result_maxlength = 20
            } else {
                this.search_result_maxlength = this.main_result.length
            }

            for (var i = 0; i < this.search_result_maxlength; i++) {
                final_result.push(this.main_result[i])
            }

            const visibleFinalResult = final_result.filter(usfIsVisibleCollectionProduct)
            const preserveSsrFirstRow = keepCollectionSsr && usfCanPreserveCollectionSsr(visibleFinalResult)

            this.preserveSsrFirstRow = preserveSsrFirstRow
            this.ssrProductCount = preserveSsrFirstRow ? usfGetCollectionSsrProductIds().length : 0
            this.items = final_result

            const finishCollectionHandoff = () => {
              if (requestId !== this.searchRequestId) return

              if (preserveSsrFirstRow) {
                usfSyncCollectionSsrPrices(
                  visibleFinalResult.slice(0, this.ssrProductCount),
                  this.shop_currency
                )
                usfShowCollectionSsrFirstRow()
                usfShowCollectionApiResults()
                usfWarmCollectionNextProductImages()
                return
              }

              usfWaitForCollectionApiImages(4, 1200).then(() => {
                if (requestId !== this.searchRequestId) return

                usfSwapCollectionSsrToApiResults()
                usfWarmCollectionNextProductImages()
              })
            }

            if (this.$nextTick) {
              this.$nextTick(finishCollectionHandoff)
            } else {
              finishCollectionHandoff()
            }

            this.show_no_result = this.main_result.length === 0

            if (this.main_result.length > 20) {
                $('.usf-btn-loadmore').show()
            } else {
                $('.usf-btn-loadmore').hide()
            }

            document.querySelectorAll('.product-count').forEach((element) => {
                let textContent = this.main_result.length

                if (element.classList.contains('desktop')) {
                    textContent += ' PRODUCT'
                } else {
                    textContent += ' products'
                }

                element.textContent = textContent
            })
        })
        .catch(() => {})

      // Price-slider formatting needs grouping's maxPrice; run only after BOTH calls succeed.
      // This mirrors the original sequential timing and avoids unhandled promise rejections.
      Promise.allSettled([groupFetch, searchFetch]).then((results) => {
        if (requestId !== this.searchRequestId) return
        if (results[0].status !== 'fulfilled' || results[1].status !== 'fulfilled') return

            const doublyCurrency = document.querySelector('select[name="doubly-currencies"]')
            const shopCurrency = this.shop_currency
            let minRangeValue = this.minRangeValue
            let maxRangeValue = this.maxRangeValue
            let formattedMinRangeValue = `${shopCurrency} ${minRangeValue}`
            let formattedMaxRangeValue = `${shopCurrency} ${maxRangeValue}`

            if (doublyCurrency) {
              let currency = this.currency = doublyCurrency.value

              if (currency != shopCurrency) {
                const refs = this.$refs
                const sliderRange = refs.sliderRange
                const convertedMinPrice = this.convert_amount(this.minPrice, currency)
                const convertedMaxPrice = this.convert_amount(this.maxPrice, currency)
                const convertedMinRangeValue = this.convert_amount(minRangeValue, currency)
                const convertedMaxRangeValue = this.convert_amount(maxRangeValue, currency)
                const currencyInLowerCase = currency.toLowerCase()
                const doubly_currency = `doubly-currency-${currencyInLowerCase}`

                minRangeValue = Math.round(convertedMinRangeValue)
                maxRangeValue = Math.round(convertedMaxRangeValue)

                refs.minRangeValue.setAttribute(doubly_currency, convertedMinRangeValue * 100)
                refs.maxRangeValue.setAttribute(doubly_currency, convertedMaxRangeValue * 100)

                sliderRange.setAttribute(`data-min-${currencyInLowerCase}-price`, Math.round(convertedMinPrice))
                sliderRange.setAttribute(`data-max-${currencyInLowerCase}-price`, Math.round(convertedMaxPrice))

                refs.minimumRange.setAttribute(`data-min-${currencyInLowerCase}-range-value`, minRangeValue)
                refs.maximumRange.setAttribute(`data-max-${currencyInLowerCase}-range-value`, maxRangeValue)
              }

              formattedMinRangeValue = this.format_amount(minRangeValue, currency)
              formattedMaxRangeValue = this.format_amount(maxRangeValue, currency)
            }

            this.formattedMinRangeValue = formattedMinRangeValue
            this.formattedMaxRangeValue = formattedMaxRangeValue

            this.update_range_position()
        })
      
      /* fetch(url_group)
      .then(response=>response.json())
      .then(suggestions=> {

        this.groupings=suggestions['groupings'];

        var current_location =  window.location.href;
        current_location = current_location.trim();

        if (this.groupings.length<=2){
           this.showGroupings = false;          
        }
        if (current_location.indexOf("bundles") > -1){
          this.showGroupings = false;
          this.showBundleBanner = true;
        }
        
        this.size_filter=suggestions['size_filter'];
        this.price_filter=suggestions['price_filter'];

        if (this.color_filter.length<=0){
          this.color_filter=suggestions['color_filter'];
        }

        for (var i = 0; i < this.groupings.length; i++) {
          group = this.groupings[i]['css_group'];
          if (group=='group_all'){
            this.total_records = this.groupings[i]['count'];
          }
        }
      }) */

      /* fetch(url_search)
      .then(response=>response.json())
      .then(result => {
        this.main_result = result;

        current_url = window.location.href;

        const wishlist = this.get_wishlist()

        this.main_result = this.main_result.map((product) => {
          const variants = JSON.parse(product.variants)

          const compareAtPrice = variants.filter((variant) => variant.node.compareAtPrice !== undefined)
            .map((variant) => parseFloat(variant.node.compareAtPrice))

          if (compareAtPrice.length > 0) {
            product.compareAtPrice = Math.max(...compareAtPrice)
          } else {
            product.compareAtPrice = 0
          }

          product.in_wishlist = wishlist.includes(product.product_id)
          product.show_outlet = product.tags.includes('"outlet"') ? 'yes' : 'no'

          return product
        })

        let x = 1;
        for (var i = 0; i < this.main_result.length; i++) {
          this.main_result[i]['ctr'] = x 

          variants = JSON.parse(this.main_result[i]['variants']);
          if (variants[0]['node']['compareAtPrice']!==undefined){
            this.main_result[i]['compareAtPrice'] = variants[0]['node']['compareAtPrice']

            minus_price = this.main_result[i]['compareAtPrice'] - this.main_result[i]['maxprice'];
            divide_price = minus_price / this.main_result[i]['compareAtPrice'];
            percentage_discount = Math.round(divide_price * 100);

            if (percentage_discount>=10 && percentage_discount <=19){
              this.main_result[i]['compareDiscount'] = '20% OFF';            
            }else if (percentage_discount>=20 && percentage_discount <=29){
              this.main_result[i]['compareDiscount'] = '20% OFF';            
            }else if (percentage_discount>=30 && percentage_discount <=39){
              this.main_result[i]['compareDiscount'] = '30% OFF';            
            }else if (percentage_discount>=40 && percentage_discount <=49){
              this.main_result[i]['compareDiscount'] = '40% OFF';            
            }else if (percentage_discount>=50 && percentage_discount <=59){
              this.main_result[i]['compareDiscount'] = '50% OFF';            
            }else {
              this.main_result[i]['compareDiscount'] = '';             
            }

            if (this.main_result[i]['title'].toLowerCase().indexOf('set')>-1){
              this.main_result[i]['compareDiscount'] = '70% OFF';                         
            }else{
              this.main_result[i]['compareDiscount'] = '70% OFF';                         
            }

            if (current_url.indexOf("buy-one-get-one") > -1){
              this.main_result[i]['compareDiscount'] = '';      
              this.showB1G1Banner = true;
            }

              // this.main_result[i]['compareDiscount'] = '';      
            
          }else{
            this.main_result[i]['compareAtPrice'] = '';
            this.main_result[i]['compareDiscount'] = '';
          }

          if (this.main_result[i]['tags'].includes('"outlet"')){
           this.main_result[i]['show_outlet'] = "yes";            
          }else{
           this.main_result[i]['show_outlet'] = "no";                        
          }
          
          // console.log(this.main_result);
          x = x+1;
        }              

        let final_result = [];

        //pagination
        if (this.main_result.length>=20){
          this.search_result_maxlength = 20;
        }else{
          this.search_result_maxlength = this.main_result.length;
        }

        for (var i = 0; i < this.search_result_maxlength; i++) {
          final_result.push(this.main_result[i]) 
        }              

        this.items = final_result;

        if (this.main_result.length==0){
          this.show_no_result = true;
        }  

        if (this.main_result.length>20){
          $('.usf-btn-loadmore').show();
        }else{
          $('.usf-btn-loadmore').hide();
        }

        document.querySelectorAll('.product-count').forEach((element) => {
          let textContent = this.main_result.length

          if (element.classList.contains('desktop')) {
            textContent += ' PRODUCT'
          } else {
            textContent += ' products'
          }

          element.textContent = textContent
        })
      }) */
    },
    search_load_more(){
      //pagination
      let start_index = this.search_result_maxlength;
      this.search_result_maxlength = this.search_result_maxlength+20;

      if (this.search_result_maxlength >= this.main_result.length){
        this.search_result_maxlength = this.main_result.length;
        $('.usf-btn-loadmore').hide();
      }

      let result = [];
      for (var i = start_index; i < this.search_result_maxlength; i++) {
        result.push(this.main_result[i]) 
      }              

      let prev_result = JSON.stringify(this.items); 
      prev_result = JSON.parse(prev_result);     
      let final_result = prev_result.concat(result);
      this.items = final_result;

      const warmLoadedBatch = () => usfWarmCollectionNextProductImages()

      if (this.$nextTick) {
        this.$nextTick(warmLoadedBatch)
      } else {
        warmLoadedBatch()
      }
    },
    clear_filter(){
      this.uf_remove_item(this.search_filter,'color');
      this.uf_remove_item(this.search_filter,'price');
      this.uf_remove_item(this.search_filter,'size');
      this.uf_remove_item(this.search_filter,'gender');
      
    },
    uf_remove_item(array, item) {
      for(i = 0; i<array.length; i++){
    item_id = array[i].id
        item_type = array[i].type 
        if (item_type=='price'){
          this.minAngle = this.defaultMinPrice;
          this.maxAngle = this.defaultMaxPrice;
        }
        if (item_type=='size'){
          $("#size_"+item_id).prop("checked",false);
          $('#size_mobile_'+item_id).removeClass("oos")
        }
        if (item_type=='color'){
          $("#color_"+item_id).prop("checked",false);
          $('#color_mobile_'+item_id).removeClass("color_selected")
        }
        if (item_type=='gender'){
          $('.mgender').removeClass("oos")
          $('#mobile_gender1').addClass("oos")
        }
      }
      
      for(i = 0; i<array.length; i++){
    item_id = array[i].id
        item_type = array[i].type 
        if(item_type == item) {
          array.splice(array.indexOf(item), 1);
          i--;
        }
      }
      
    },    
    uf_showfiter(filter){

      if ($('.detail-'+filter).css('display') == 'none'){
        $(".arrow-"+filter).addClass('down');
        $(".arrow-"+filter).removeClass('up');          
        $('.detail-'+filter).show();
      }else{
        $(".arrow-"+filter).removeClass('down');
        $(".arrow-"+filter).addClass('up');          
        $('.detail-'+filter).hide();
      }


    },
    uf_remove_filter(type,id,label){
      let index = this.search_filter.map((el) => el.id).indexOf(id);
      if (index > -1) {
        this.search_filter.splice(index, 1);
        if (type=='price'){
          this.minAngle = this.defaultMinPrice;
          this.maxAngle = this.defaultMaxPrice;
        }
        if (type=='size'){
          $("#size_"+id).prop("checked",false);
          $('#size_mobile_' + id).removeClass("oos")
        }
        if (type=='color'){
          $("#color_"+id).prop("checked",false);
          $('#color_mobile_' + id).removeClass("color_selected")
        }
        if (type=='gender'){
          $('.mgender').removeClass("oos")
          $('#mobile_gender1').addClass("oos")
        }
      }            
    },
    uf_add_size_filter(id,size){
      if ($('#size_' + id).is(":checked")){
        $('#size_mobile_' + id).addClass("oos")
        this.search_filter.push({'id':id,'type':'size','label':size});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          $('#size_mobile_' + id).removeClass("oos")
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_add_size_mobile_filter(id,size){
      if (!$('#size_mobile_' + id).hasClass("oos")){
        $("#size_"+id).prop("checked",true);
        $('#size_mobile_' + id).addClass("oos")
        this.search_filter.push({'id':id,'type':'size','label':size});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          $("#size_"+id).prop("checked",false);
          $('#size_mobile_' + id).removeClass("oos")
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_add_gender_mobile_filter(id,gender,obj_id){
      if (gender=='all'){
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter.splice(index, 1);
        }             
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter[index]['label'] = gender;
        }else{
          this.search_filter.push({'id':'111_gender','type':'gender','label':gender});
        }
      }

      $('.mgender').removeClass("oos")
      $('#mobile_gender' + obj_id).addClass("oos")
    },
    uf_add_color_filter(id,color){
      if ($('#color_'+id).is(":checked")){
        this.search_filter.push({'id':id,'type':'color','label':color});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_add_sort_filter(id,sort){
      let index = this.search_filter.map((el) => el.id).indexOf(id);
      if (index > -1) {
        this.search_filter[index]['label'] = sort;
      }else{
        this.search_filter.push({'id':'111_sort','type':'sort','label':sort});
      }

    },
    uf_add_gender_filter(id,gender){
      if (gender=='all'){
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter.splice(index, 1);
        }             
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter[index]['label'] = gender;
        }else{
          this.search_filter.push({'id':'111_gender','type':'gender','label':gender});
        }
      }
      $('#gfirstoption').removeClass("ckchecked")
    },
    uf_add_color_mobile_filter(id,color){
      if (!$('#color_mobile_' + id).hasClass("color_selected")){
        $("#color_"+id).prop("checked",true);
        $('#color_mobile_' + id).addClass("color_selected")
        this.search_filter.push({'id':id,'type':'color','label':color});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          $("#color_"+id).prop("checked",false);
          $('#color_mobile_' + id).removeClass("color_selected")
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_get_max_id(obj){
      return (Math.max.apply(Math, obj.map(function(o) {
        return o.id;
      })) + 0);
    },
    uf_test: function(obj){
      //console.log(obj);
    },
    uf_mobile_size_menu: function(obj){
      mp_title = $('#mp_title'+obj.product_id).val();
      $('#mp_variant_id_selected').val('');
      $('#btn-mobile-add').html('SELECT A SIZE');   
      $('#btn-mobile-add').removeClass('add_selected'); 

      if (mp_title!=''){
        return;
      }

      let variants = JSON.parse(obj.variants);
      let processed_variants = [];
      let default_variant_id = '';  

      for (var i = 0; i < variants.length; i++) {
        id = variants[i]['node']['id'];
        title = variants[i]['node']['title'];
        availableForSale = variants[i]['node']['availableForSale'];
        price = variants[i]['node']['price'];

        if (availableForSale){
          if (title=='Default Title'){
            default_variant_id = id;
          }
        }

        let arr_title = title.split('/');
        if (arr_title[0].length <= 6) {
          processed_variants.push({'id':id,'title':arr_title[0],'availableForSale':availableForSale,'price':price});
        }
      } 

      $('#mp_id').val(obj.product_id);
      $('#mp_default_variant'+obj.product_id).val(default_variant_id);
      $('#mp_title'+obj.product_id).val(obj.title);
      $('#mp_image'+obj.product_id).val(obj.featured_image);
      $('#mp_price'+obj.product_id).val(obj.maxprice);
      $('#mp_size'+obj.product_id).val(JSON.stringify(processed_variants));
    },
    in_array: function (needle,haystack){
      let return_value = false;
      for (var i = 0; i < haystack.length; i++) {
        if (haystack[i]['type']==needle){
          return_value = true;
        }else{
          return_value = false;
        }
      }
      return return_value;
    },
    handleScroll: function() {
      //console.log('xxx');
    },
    uf_mouseover: function(product_id) {
      const image = $('.product_image2_'+ product_id).val()

      if (image) {
        const image_url = `url(${image})`

        $('.product-block__image.product_' + product_id).css({
          'background-image': image_url
        })
      }
    },  
    uf_mouseleave: function(product_id) {
      const image = $('.product_image1_'+ product_id).val()

      if (image) {
        const image_url = `url(${image})`

        $('.product-block__image.product_' + product_id).css({
          'background-image': image_url
        })
      }
    },
    updateScreenSize(mediaQuery) {
      this.screenSize = mediaQuery.matches ? 'mobile' : 'desktop'
      this.isMobile = this.screenSize === 'mobile'
      this.show_filters = this.show_filter_body = !this.isMobile
      let productView = 'grid'

      if (this.isMobile) {
        productView = this.productView
      }

      this.$refs.results.style.display = productView
    },
    handle_toggle_sort_dropdown() {
      const sortMenu = document.getElementById('sort-menu')
      const sortMenuClasses = sortMenu.classList

      sortMenuClasses.toggle('active')

      const angle = sortMenuClasses.contains('active') ? 180 : 0
      const sortIcon = this.isMobile ? this.$refs.mobileSortIcon : this.$refs.desktopSortIcon

      sortIcon.style.transform = `rotate(${angle}deg)`
    },
    handle_close(e) {
      e.target.classList.remove('active')
    },
    handle_view_by_grid() {
      this.$refs.results.style.display = this.productView = 'grid'
    },
    handle_view_by_single() {
      this.preserveSsrFirstRow = false
      this.ssrProductCount = 0
      usfCancelCollectionImageWarmup()
      usfHideCollectionSsrFirstRow()

      const applySingleView = () => {
        const style = this.$refs.results.style

        style.display = this.productView = 'flex'
        style.flexDirection = 'column'
      }

      if (this.$nextTick) {
        this.$nextTick(applySingleView)
      } else {
        applySingleView()
      }
    },
    handle_toggle_filter() {
      let show_filter_body = this.show_filter_body
      const refs = this.$refs

      this.show_filter_body = show_filter_body = !show_filter_body

      if (!this.isMobile) {
        refs.filters.style.minWidth = !show_filter_body ? '0px' : '300px'
      } else {
        this.show_filters = show_filter_body
      }
    },
    add_sort_by(e) {
      const { checked, value } = e.target

      if (checked) {
        const index = this.search_filter.findIndex((filter) => filter.type === 'sort_by')
        const filter = {
          'type': 'sort_by',
          'label': value
        }

        if (index === -1) {
          this.search_filter.push(filter)
        } else {
          this.search_filter[index] = filter
        }

        this.selected_sort_by = value
      }

      this.appendToUrl = true

      if (this.isMobile) {
        this.submit_filter = true
      }
    },
    add_promotion_filter(e) {
      const { checked, value } = e.target

      if (checked) {
        this.search_filter.push({
          'type': 'promotion',
          'label': value
        });
      } else {
        this.search_filter = this.search_filter.filter((param) => {
          const { type, label } = param

          if (type === 'promotion') {
            return label !== value
          }

          return true
        })
      }

      this.appendToUrl = true
    },
    add_color_filter(e) {
      const { checked, value } = e.target

      if (checked) {
        this.search_filter.push({
          'type': 'color',
          'label': value
        });
      } else {
        this.search_filter = this.search_filter.filter((param) => {
          const { type, label } = param

          if (type === 'color') {
            return label !== value
          }

          return true
        })
      }

      this.appendToUrl = true
    },
    add_category_filter(e) {
      const { checked, value } = e.target

      if (checked) {
        this.search_filter.push({
          'type': 'category',
          'label': value
        })
      } else {
        this.search_filter = this.search_filter.filter((param) => {
          const { type, label } = param

          if (type === 'category') {
            return label !== value
          }

          return true
        })
      }

      this.appendToUrl = true
    },
    add_size_filter(e) {
      const { checked, value } = e.target

      if (checked) {
        this.search_filter.push({
          'type': 'size',
          'label': value
        })
      } else {
        this.search_filter = this.search_filter.filter((param) => {
          const { type, label } = param

          if (type === 'size') {
            return label !== value
          }

          return true
        })
      }

      this.appendToUrl = true
    },
    add_fit_filter(e) {
      const { checked, value } = e.target

      if (checked) {
        this.search_filter.push({
          'type': 'fit',
          'label': value
        })
      } else {
        this.search_filter = this.search_filter.filter((param) => {
          const { type, label } = param

          if (type === 'fit') {
            return label !== value
          }

          return true
        })
      }

      this.appendToUrl = true
    },
    add_price_filter() {
      const checkFilter = (current_type) => {
        return this.search_filter.find(({ type }) => type === current_type)
      }

      const minPrice = checkFilter('min_price')
      const maxPrice = checkFilter('max_price')
      const minRangeValue = this.minRangeValue
      const maxRangeValue = this.maxRangeValue

      if (minPrice === undefined) {
        this.search_filter.push({
          type: 'min_price',
          label: minRangeValue
        })
      } else {
        minPrice.label = minRangeValue
      }

      if (maxPrice === undefined) {
        this.search_filter.push({
          type: 'max_price',
          label: maxRangeValue
        })
      } else {
        maxPrice.label = maxRangeValue
      }

      this.appendToUrl = true
    },
    clear_filters() {
      this.search_filter = this.search_filter.filter(({ type }) => {
        const allowed = ['collection', 'query']

        return allowed.includes(type)
      })

      const url = new URL(location.href)

      url.searchParams.delete('filters')

      window.history.pushState({}, '', url)

      document.querySelectorAll('div.filter-values input[type="checkbox"]').forEach((element) => {
        element.checked = false
      })

      this.selected_sort_by = 0
      this.selected_promotion = []
      this.selected_color = []
      this.selected_category = []
      this.selected_size = []
      this.selected_fit = []
      this.minRangeValue = 0
      this.maxRangeValue = this.maxPrice
      this.update_range_position()
      this.show_filters = this.show_filter_body = false
      this.search()
      this.scroll_to_results()
    },
    apply_filters() {
      const search_filter = this.search_filter
      const filters = JSON.stringify(search_filter)
      const encoded = encodeURIComponent(filters)
      const url = new URL(location.href)

      if (search_filter.length > 0) {
        url.searchParams.set('filters', encoded)
      }

      window.history.pushState({}, '', url)

      this.show_filters = this.show_filter_body = false
      this.search()
      this.scroll_to_results()
    },
    scroll_to_results() {
      const targetRef = this.$refs.mobileActions
      const headerHeight = document.querySelector('header').offsetHeight;
      const yOffset = targetRef.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    },
    start_slider_drag(type) {
      this.dragging = type

      document.addEventListener('mousemove', this.on_slider_drag)
      document.addEventListener('mouseup', this.stop_slider_drag)
      document.addEventListener('touchmove', this.on_slider_drag, { passive: false })
      document.addEventListener('touchend', this.stop_slider_drag, { passive: false })

      return false
    },
    stop_slider_drag() {
      if (!this.dragging) return;

      this.dragging = null;

      document.removeEventListener('mousemove', this.on_slider_drag)
      document.removeEventListener('mouseup', this.stop_slider_drag)
      document.removeEventListener('touchmove', this.on_slider_drag, { passive: false })
      document.removeEventListener('touchend', this.stop_slider_drag, { passive: false })

      this.add_price_filter()
    },
    convert_amount(amount, new_currency) {
      return DoublyGlobalCurrency.convert(amount, this.shop_currency, new_currency)
    },
    format_amount(amount, currency) {
      const newFormat = DoublyGlobalCurrency.moneyFormats[currency][DoublyGlobalCurrency.format]

      return DoublyGlobalCurrency.formatMoney(amount * 100, newFormat)
    },
    getMaxPrice() {
      const shopCurrency = this.shop_currency
      const currency = this.currency?.toLowerCase()

      if (currency) {
        if (currency != shopCurrency) {
          return this.$refs.sliderRange.getAttribute(`data-max-${currency}-price`)
        }
      }

      return this.maxPrice
    },
    update_range_position() {
      // const priceRange = this.maxPrice - this.minPrice

      // this.minRangePosition = ((this.minRangeValue - this.minPrice) / (priceRange)) * 100
      // this.maxRangePosition = ((this.maxPrice - this.maxRangeValue) / (priceRange)) * 100

      this.minRangePosition = (this.minRangeValue / this.maxPrice) * 100
      this.maxRangePosition = 100 - (this.maxRangeValue / this.maxPrice) * 100
    },
    on_slider_drag(event) {
      const dragging = this.dragging

      if (!dragging) return;

      let position = {}
      const touches = event.touches

      if (touches && touches.length > 0) {
        position = {
          clientX: touches[0].clientX,
          clientY: touches[0].clientY
        }
      } else {
        position = {
          clientX: event.clientX,
          clientY: event.clientY
        }
      }

      const doublyCurrency = document.querySelector('select[name="doubly-currencies"]')
      const shopCurrency = this.shop_currency
      let currency = doublyCurrency ? doublyCurrency.value : null
      const rect = this.$refs.sliderWrapper.getBoundingClientRect()
      const offsetX = position.clientX - rect.left
      const percentage = (offsetX / rect.width) * 100
      const maxPrice = this.getMaxPrice()

      if (dragging === 'min') {
        const maxLeft = 100 - this.maxRangePosition
        const newLeft = Math.max(0, Math.min(percentage, maxLeft - 15)) / 100
        const minRangeValue = Math.round(newLeft * this.maxPrice)
        let formattedMinRangeValue = `${shopCurrency} ${minRangeValue}`

        this.minRangeValue = minRangeValue

        if (doublyCurrency) {
          const convertedMinRangeValue = Math.round(newLeft * maxPrice)

          formattedMinRangeValue = this.format_amount(Math.round(convertedMinRangeValue), currency)
        }

        this.formattedMinRangeValue = formattedMinRangeValue
      } else if (dragging === 'max') {
        const minRight = this.minRangePosition
        const newRight = (100 - Math.max(0, Math.min(100 - percentage, 100 - minRight - 15))) / 100
        const maxRangeValue = Math.round(newRight * this.maxPrice)
        let formattedMaxRangeValue = `${shopCurrency} ${maxRangeValue}`

        this.maxRangeValue = maxRangeValue

        if (doublyCurrency) {
          const convertedMaxRangeValue = Math.round(newRight * maxPrice)

          formattedMaxRangeValue = this.format_amount(Math.round(convertedMaxRangeValue), currency)
        }

        this.formattedMaxRangeValue = formattedMaxRangeValue
      }

      this.update_range_position()
    },
    get_wishlist() {
      const cookie = document.cookie.split('; ')
        .find((cookie) => {
          const [key] = cookie.split('=')

          return key === 'wishlist'
      })

      let product_ids = []

      if (cookie !== undefined) {
          const [_, values] = cookie.split('=')

          product_ids = values.split(',')
      }

      return product_ids
    },
    set_wishlist(values, days = 30) {
      values = values.join(',')

      const date = new Date()

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)

      document.cookie = `wishlist=${values}; expires=${date.toUTCString()}; path=/`
    },
    delete_wishlist() {
      document.cookie = 'wishlist=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    },
    add_to_wishlist(product_id) {
      let wishlist = this.get_wishlist()

      wishlist.push(product_id)

      this.set_wishlist(wishlist)

      const wishlistButtons = document.querySelector(`div.wishlist-buttons[data-product-id="${product_id}"]`)

      wishlistButtons.querySelector('.add-to-wishlist').style.display = 'none'
      wishlistButtons.querySelector('.remove-from-wishlist').style.display = 'block'
    },
    remove_from_wishlist(product_id) {
      let wishlist = this.get_wishlist()

      wishlist = wishlist.filter((id) => id !== product_id)

      if (wishlist != '') {
        this.set_wishlist(wishlist)
      } else {
        deleteWishlist()
      }

      const wishlistButtons = document.querySelector(`div.wishlist-buttons[data-product-id="${product_id}"]`)

      wishlistButtons.querySelector('.add-to-wishlist').style.display = 'block'
      wishlistButtons.querySelector('.remove-from-wishlist').style.display = 'none'
    },
  },
  components: {
    'usf-render-color': RenderColor,
    'usf-render-size': RenderSize
  } 
}

var element =  document.getElementById('usf_container');
if (typeof(element) != 'undefined' && element != null)
{
  // Vue's client mount rebuilds the mount container. Detach the Shopify-rendered
  // first row first, then put the same DOM nodes back beside the API grid.
  var collectionSsrFirstRow = document.getElementById('collection-ssr-first-row');

  if (collectionSsrFirstRow && collectionSsrFirstRow.parentNode) {
    collectionSsrFirstRow.parentNode.removeChild(collectionSsrFirstRow);
  }

  const SearchPage = Vue.createApp(SearchPageOptions).mount('#usf_container');

  if (collectionSsrFirstRow) {
    var collectionApiResults = document.getElementById('divresults');

    if (collectionApiResults && collectionApiResults.parentNode) {
      collectionApiResults.parentNode.insertBefore(collectionSsrFirstRow, collectionApiResults);
    }
  }
}


$( ".usf-filter-item" ).mouseleave(function() {
      $(".arrow").removeClass('down');
      $(".arrow").addClass('up'); 
      $('.usf-detail').hide();
});


$( document ).ready(function() {
  
  
  $( ".usf-facet" ).click(function() {
    $(".usf-facet").addClass( "usf-collapsed" );
    $( this ).removeClass( "usf-collapsed" );
  });
  
  $(document).find('.usf-filter-item').removeClass('active');
  
  $( ".usf-filter-item" ).on('mouseup',function() {
      
    if( $( ".usf-filter-item" ).hasClass('active')){
      $(this).toggleClass("active");

//         setTimeout(function() {
//           $(document).find('.usf-detail').hide();
//         }, 10);
    }
  });

  
});
